import Repository from '@/libs/axios'

const webhookLogsResource = '/merchant/webhook/logs'
const webhookResource = '/merchant/webhook'

const defaultPagination = 10

export default {
  getAllWebhookLogs(pageNumber = 1, filterQuery = '', pagination = defaultPagination) {
    return Repository.get(`${webhookLogsResource}/view?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getWebhookLogById(id) {
    return Repository.get(`${webhookLogsResource}/${id}`)
  },
  getAllWebhookLogsNoPagination(filterQuery = '') {
    return Repository.get(`${webhookLogsResource}/view?${filterQuery}&noPagination`)
  },
  getWebhooksConfiguration(filterQuery = '') {
    return Repository.get(`${webhookResource}?${filterQuery}`)
  },
  getWebhookConfig() {
    return Repository.get(`${webhookResource}/config`)
  },
  addWebhook(payload) {
    return Repository.post(`${webhookResource}/add-webhook`, payload)
  },
  updateWebhook(id, payload) {
    return Repository.put(`${webhookResource}/${id}/update`, payload)
  },
}
